/**********************************

Cookie functions

***********************************/
//Sets a cookie with the given name and value for the current session.
function setSessionCookie(name, value) {
  let date = new Date();
  document.cookie = name + "=" + value + "; " + "; path=/";
}
//Gets a cookie with the given name.
function getSessionCookie(name) {
  const nameKey = name + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

/***********************************/

// Start IPStack Geotargeting based on customers zipcode //

function getCookie(e) {
  return document.cookie.length > 0 &&
    ((c_start = document.cookie.indexOf(e + "=")), -1 != c_start)
    ? ((c_start = c_start + e.length + 1),
      (c_end = document.cookie.indexOf(";", c_start)),
      -1 == c_end && (c_end = document.cookie.length),
      unescape(document.cookie.substring(c_start, c_end)))
    : "";
}
function setCookie(e, t, c) {
  var o;
  if (c) {
    var n = new Date();
    n.setTime(n.getTime() + 24 * c * 60 * 60 * 1e3),
      (o = "; expires=" + n.toGMTString());
  } else o = "";
  document.cookie = e + "=" + t + o + "; path=/";
}
var zipcode = getCookie("zipcode");
var access_key = "9da7c901697562382ec847a53ec9dd4e";
if (zipcode == "") {
  $.ajax({
    url: "https://api.ipstack.com/check" + "?access_key=" + access_key,
    dataType: "jsonp",
    success: function (json) {
      //console.log(json);
      //alert(json.zip);
      if (json.zip) setCookie("zipcode", json.zip, 5);
    },
  });
} else {
  console.log("that worked");
}

// End IPStack Geotargeting based on customers zipcode //


// Start Geotargeting First Load Fix //
function geoTarget(){
    var zipcode = getCookie("zipcode");
    console.log("fast geo zip " + zipcode);
    $("#enterzipcode").val(zipcode);
    // Directly submit the form
    $("#shipping-arrival").submit();
}

 setTimeout(geoTarget, 500);
// End Geotargeting First Load Fix //
